import { observer } from 'mobx-react-lite';

import * as React from 'react';
import ActionableMessageCardStrings from '../store/schema/ActionableMessageCardStrings';

import { TextField } from '@fluentui/react/lib/TextField';
import { NumberValidation, validateNumber } from '../utils/validateNumber';

export interface NumberTextFieldProps {
    placeholder: string;
    min: string;
    max: string;
    required: boolean;
    value: string;
    strings: ActionableMessageCardStrings;
    onValueChanged: (value: string) => void;
}

export const NumberTextField = observer(function NumberTextField(props: NumberTextFieldProps) {
    const [value, setValue] = React.useState<string>(props.value);
    const { min, max } = props;
    const validateNumber_0 = (value: string): string => {
        const { strings, onValueChanged } = props;
        const numberValidation: NumberValidation = validateNumber(value, min, max);
        onValueChanged(value);
        switch (numberValidation) {
            case NumberValidation.LessThanMin:
                return strings.format(strings.warning.inputNumberLessThanMin, min);
            case NumberValidation.MoreThanMax:
                return strings.format(strings.warning.inputNumberMoreThanMax, max);
            case NumberValidation.NotNumber:
                return strings.warning.inputNumberNotNumeric;
            case NumberValidation.Ok:
            default:
                return '';
        }
    };
    const onChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ): void => {
        props.onValueChanged(newValue);
        setValue(newValue);
    };
    return (
        <TextField
            type="number"
            value={value}
            min={min}
            max={max}
            onChange={onChange}
            required={props.required}
            placeholder={props.placeholder}
            onGetErrorMessage={validateNumber_0}
        />
    );
});
